import React, { PropTypes } from "react";
import { FormattedDate, FormattedTime, FormattedMessage } from "react-intl";
import loading from "../../assets/images/loading.png";
import success from "../../assets/images/success.png";
import error from "../../assets/images/error.png";
import { getNotificationDetail } from "../dashboard/synchronization/SynchronizationDataHelper";
import { getErrorValues } from "../common/synchronization/SynchronizationHelper";

class SyncedNotificationsListItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getImageUrl = this.getImageUrl.bind(this);
  }


  getImageUrl(status) {
    switch (status) {
      case "STARTED":
        return loading;
      case "SUCCESS":
        return success;
      case "FAILURE":
        return error;
    }
  }

  render() {
    const { syncNotification } = this.props;
    const notificationStatus = syncNotification.status;
    const imageUrl = this.getImageUrl(notificationStatus);

    const notificationTitle = (
      <FormattedMessage id="clients.client.processSync.notificationsBoard.details.titles.adjudicareSynchronization" />
    );

    const createdAt = new Date(syncNotification.syncDate + 'Z');
        
    const icon = (
      <span className="icon">
        <img src={imageUrl} type="logo" style={{ width: "20px" }} />
      </span>
    );
    return (
      <div className="line-item" style={{cursor: "default"}}>
        <div className="header" style={{ marginBottom: "10px", alignItems: "center" }}>
          {getErrorValues(syncNotification, icon, "left")}
          <span className="name" style={{ width: "auto", paddingLeft: "10px" }}>{notificationTitle}</span>
          <span className="date" style={{fontSize: "11px"}}>
            <FormattedTime
              value={createdAt}
              hour="numeric"
              minute="numeric"
            />
            &nbsp;&nbsp;-&nbsp;&nbsp;
            <FormattedDate
              value={createdAt}
              year="2-digit"
              month="2-digit"
              day="2-digit"
            />
          </span>
        </div>
        <span style={{ display: "none" }}/>
        { <p className="description-synchro" style={{ paddingLeft: "0px" }}>{getNotificationDetail(syncNotification, true,true)}</p>}
      </div>
    );
  }
}

SyncedNotificationsListItem.propTypes = {
  syncNotification: PropTypes.object
};

export default SyncedNotificationsListItem;


// WEBPACK FOOTER //
// ./src/components/dashboard/SyncedNotificationsListItem.js